export { MultiRoomGuestDetailsStepContainer as MultiRoomGuestDetailsStep } from './container';
